module.exports = __webpack_public_path__ + "static/media/logo.f1ee1af9.svg";